export default __webpack_public_path__ + "static/media/apple store.359f9cf6.png";